module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href="/#person/'+
((__t=( signerId ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( signerName ))==null?'':__t)+
'</a></td>\r\n<td>';
 if ((documentsWithSignedDate || []).length != 0) { 
__p+='\r\n    <div class="documents-show center clickable" title="Documents">\r\n        <span class="badge">'+
((__t=( (documentsWithSignedDate || []).length ))==null?'':__t)+
'</span>\r\n    </div>\r\n    ';
 } 
__p+='\r\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/statistics/document-sign-statistic-row.html
// module id = 465
// module chunks = 0